<template>
    <div>
    <header class="header">
      <div class="header-wrapper">
        <div class="header-logo" @click="logoClick">
          <img src="../assets/images/index/logo@2x.png" alt="">
        </div>
        <div class="company">澜思信息科技旗下</div>
        <ul class="navBarList">
          <li class="navBarList-item chooseLancheng">
            <div class="li-item-title" @click="chooseClick">为什么选择澜城数据 <span class="triangle"></span></div>
            <div class="choose-lancheng">
              <div class="content-text" v-for="(item,index) in chooseLanchengList" :key="index" @click="advantageClick(index)">{{item.text}}</div>
            </div>
          </li>
          <li class="navBarList-item productIntro">
            <div class="li-item-title" @click="productIntroClick"><span>产品介绍</span> <span class="triangle"></span></div>
            <div class="product-intro">
              <div class="content-text" @click="openplatformClick">澜城数据开放平台</div>
              <div class="content-text" @click="resClick">RES房地产数据分析系统</div>
              <div class="content-text" @click="xiaofangshuClick">小房书门店管理系统</div>
              <div class="content-text" @click="chengtuClick">城市地图数据分析决策系统</div>
              <div class="content-text" @click="rasClick">RAS房地产价格跟踪系统</div>
            </div>
          </li>
        </ul>
        <div class="open-platform" @click="lpkOpenPlatformClick">楼盘库开放平台</div>
        <div class="userInfo" v-if="this.$store.state.userInfoFlag">
          <div class="login-name">{{this.$store.state.username}}<span class="triangle"></span></div>
          <div class="login-img">{{this.$store.state.username ? this.$store.state.username.substring(this.$store.state.username.length - 2) : ''}}</div>
          <div @click="loginoutClick" class="loginout">退出登录</div>
        </div>
        <div v-else>
          <div class="register" @click="registerClick">注册
            <div class="layer"></div>
          </div>
          <div class="login" @click="loginClick">登录</div>
        </div>
      </div>
    </header>
    </div>
</template>

<script>
export default {
  props: ["isLogin", "phoneNumber", "smsCode", "passwordNumber"],
  data() {
    return {
      username: "",
      navBarId: null,
      isLoginFlag: false,
      navBarList: [
        {
          categoryName: "为什么选择澜城数据"
        },
        {
          categoryName: "产品介绍"
        },
        {
          categoryName: "开发支持"
        }
      ],
      chooseLanchengList: [
        {
          text: "成功案例"
        },
        {
          text: "市场优势"
        },
        {
          text: "服务优势"
        }
      ],
      productIntroList: [
        {
          text: "RAS房地产价格跟踪系统"
        },
        {
          text: "城市地图数据分析决策系统"
        },
        {
          text: "'HOUSEBOOK'小房书门店管理系统"
        },
        {
          text: "澜城数据开放平台"
        },
        {
          text: "RES房地产数据分析系统"
        }
      ],
      chooseLancheng: false,
      productIntro: false,
    };
  },
  methods: {
    logoClick() {
      this.$router.push("/");
    },
    chooseClick(){
      this.$router.push("./advantage")
    },
    advantageClick(index){
      if(this.$route.path !== '/advantage') {
        this.$router.push({path: './advantage', query: {name: index}})
      } else {
        this.$router.push("./advantage")
      }
      this.$emit('navbarClick', index)
    },
    productIntroClick(){
      this.$router.push("./productIntroOpenPlatform")
    },
    rasClick(){
      this.$router.push("./productIntroRas")
    },
    chengtuClick(){
      this.$router.push("./productIntroChengTu")
    },
    xiaofangshuClick(){
      this.$router.push("./productIntroXiaofangshu")
    },
    openplatformClick(){
      this.$router.push("./productIntroOpenPlatform")
    },
    resClick(){
      this.$router.push("./productIntroRes")
    },
    // 触发事件--点击楼盘库开放平台时
    lpkOpenPlatformClick() {
      const self = this;
      let token = self.Cookies.get('LPKTOKEN',{ path: '/', domain: 'citywavedata.com' });
      if(token) {
        window.open('http://opfcontrol.citywavedata.com/home');
      } else {
        if(self.$store.state.userInfoFlag) {
          setTimeout(() => {
            window.location.reload();
          }, 0)
        } else {
          self.loginClick();
        }
      }
    },
    // 登录
    loginClick() {
      // 登录之前先将input值清空
      this.$store.state.phoneNumber = "";
      this.$store.state.smsCode = "";
      this.$store.state.passwordNumber = "";

      this.$store.state.isLogin = true;
    },
    // 注册
    registerClick() {
      this.$router.push("/register");
    },
    // 退出
    loginoutClick() {
      const self = this;
      self.$store.state.userInfoFlag = false;
      // 清除cookie信息
      self.Cookies.remove('LPKTOKEN', { path: '/', domain: 'citywavedata.com' });
      self.Cookies.remove('USERINFO', { path: '/', domain: 'citywavedata.com' });
      // 清除localStorage信息
      window.localStorage.clear();
    }
  },
  created() {
    const self = this;
    let username = window.localStorage.getItem("username");
    let token = self.Cookies.get('LPKTOKEN',{ path: '/', domain: 'citywavedata.com' });
    if (token) {
      // 用户刷新时，控制显示状态
      self.$store.state.userInfoFlag = true;
      self.$store.state.username = username;
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 56px;
  background: #021a3c;
  border-top: 1px solid transparent;

  .header-wrapper {
    width: 1140px;
    height: 32px;
    margin: 12px auto;
    display: flex;

    .header-logo {
      width: 104px;
      height: 32px;
      float: left;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .company {
      margin-left: 33px;
      line-height: 32px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      opacity: .85;
      float: left;
    }

    .navBarList {
      width: 423px;
      height: 32px;
      margin-left: 70px;
      display: flex;
      float: left;
      position: relative;

      .navBarList-item {
        padding: 0 22px;
        height: 300px;
        font-size: 14px;
        line-height: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;

        .li-item-title {
          line-height: 32px;

          .triangle {
            width: 0;
            height: 0;
            border: 4px solid transparent;
            border-top-color: #fff;
            margin-left: 8px;
            display: inline-block;
          }

          .active {
            border-top-color: #3880f4;
          }
        }

        .choose-lancheng,
        .product-intro {
          width: 145px;
          background: #021a3c;
          position: absolute;
          top: 44px;
          left: 5.5%;
          z-index: 99;
          display: none;

          .content-text {
            width: 100%;
            height: 50px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 12px;
            cursor: pointer;
          }
        }

        .product-intro {
          width: 215px;
          left: 29.5%;
        }
      }
      li:hover {
        .li-item-title {
          color: #3880f4;

          .triangle {
            border-top-color: #3880f4;
          }
        }
      }

      .chooseLancheng:hover {
        .li-item-title {
          color: #3880f4;

          .triangle {
            border-top-color: #3880f4;
          }
        }
        .choose-lancheng {
          display: block;
        }
      }
      .productIntro:hover {
        .li-item-title {
          color: #3880f4;

          .triangle {
            border-top-color: #3880f4;
          }
        }
        .product-intro {
          display: block;
        }
      }

      .active {
        color: #3880f4;
      }
    }

    .open-platform {
      color: #fff;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 32px;
      margin-left: 160px;
      opacity: 0.85;
      cursor: pointer;

      &:hover {
        opacity: 1;
      }
    }

    .login,
    .register {
      width: 45px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      border-radius: 2px;
      opacity: 0.54;
      border: 1px solid #ffffff;
      float: right;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      margin-left: 40px;
      margin-top: 3px;
      float: right;
      cursor: pointer;
    }
    .login:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    .register {
      line-height: 25px;
      background: #3880f4;
      color: #fff;
      opacity: 1;
      border: none;
      margin-left: 16px;
      position: relative;

      .layer {
        width: 45px;
        height: 24px;
        background: rgba(0, 0, 0, 0.25);
        position: absolute;
        top: 0;
        left: 0;
        display: none;
      }

      &:hover {
        .layer {
          display: block;
        }
      }
    }

    .userInfo {
      width: 130px;
      height: 80px;
      float: right;
      position: relative;

      &:hover .loginout {
        display: block;
      }
    }

    .login-img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      float: right;
      border-radius: 50%;
      background: #3880f4;
      text-align: center;
      line-height: 32px;
      color: #fff;
      font-size: 12px;
    }

    .login-name {
      margin-left: 16px;
      line-height: 32px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      float: right;
      opacity: 0.85;
      cursor: pointer;

      .triangle {
        width: 0;
        height: 0;
        border: 4px solid transparent;
        border-top-color: #fff;
        margin-left: 8px;
        display: inline-block;
      }

      &:hover {
        opacity: 1;
      }
    }
    .loginout {
      width: 100px;
      height: 40px;
      background: #021a3c; // 021a3c
      text-align: center;
      line-height: 40px;
      position: absolute;
      right: -26px;
      top: 44px;
      z-index: 999;
      color: #fff;
      font-size: 12px;
      cursor: pointer;
      display: none;

      &:hover{
        color: #3880f4;
      }
    }

    .content-text:hover {
      background: rgba(255, 255, 255, 0.06);
    }
  }
}
</style>


